import React from "react";
import { getIcon } from "../../helpers/icons";
import { generateMediaUrl } from "../../helpers/media";
import Link from "../Link";
import Title from "../Title";
import style from "./style.module.css";

export default function CategoryList({ item = [], type = "tag", tag = "h6" }) {
    if (!item.length) return null;

    return (
        <div className={`${style.categoryList} ${type === "tag" ? style.tagList : ""}`}>
            {
                type === "tag" && (
                    <div className={style.categoryItemIcon}>
                        <i className={getIcon("Tag")}></i>
                    </div>
                )
            }
            <div className={style.categoryRow}>
                {
                    item.map((data, index) => (
                        <div key={`${type}_${index}`} className={`${style.categoryItem} ${data.type !== undefined && data.url !== undefined ? style.categoryLinkYes : ''}`}>
                            {
                                type === "tag" && (
                                    <span className={style.dot}></span>
                                )
                            }
                            {
                                data.type !== undefined && data.url !== undefined && (
                                    <Link className={style.fullBlock} to={`/${data.type}/${data.url}`}></Link>
                                )
                            }
                            {
                                type === "category" && data.image && (
                                    <img
                                        src={generateMediaUrl(data.image, "16x16")}
                                        alt="category_icon"
                                    />
                                )
                            }
                            <Title
                                className={tag === "h6" ? "textUpperCase" : ""}
                                tag={tag}
                            >
                                {data.name}
                            </Title>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
